import type { AudioPoint, ActivityCue } from './audio-activity.js';
export type DetectorTraveler = AudioPoint & { id: number; player: boolean };

/** Detect the path crossing the arch, including movement between rendered frames. */
export class AirportDetectorAudio {
  private previous = new Map<number, AudioPoint>();
  poll(gate: AudioPoint, travelers: DetectorTraveler[]): ActivityCue[] {
    const cues: ActivityCue[] = [], active = new Set<number>();
    for (const traveler of travelers) {
      active.add(traveler.id);
      const previous = this.previous.get(traveler.id);
      if (previous && ((previous.y < gate.y && traveler.y >= gate.y) || (previous.y > gate.y && traveler.y <= gate.y))) {
        const progress = (gate.y - previous.y) / (traveler.y - previous.y);
        const crossingX = previous.x + (traveler.x - previous.x) * progress;
        if (Math.abs(crossingX - gate.x) <= 45) {
          cues.push({ sound: traveler.player ? 'apt-detector-alarm' : 'apt-detector-pass', position: gate, volume: 1.4 });
        }
      }
      this.previous.set(traveler.id, { x: traveler.x, y: traveler.y });
    }
    for (const id of this.previous.keys()) if (!active.has(id)) this.previous.delete(id);
    return cues;
  }
  clear(): void { this.previous.clear(); }
}
